import { useTranslation } from 'react-i18next'
import { useToast } from '../../../components/ui/ToastProvider'
import ManagerListPicker from '../../managerLists/components/ManagerListPicker'
import type { ManagerList } from '../../managerLists/types'
import { withListMembers } from '../groupInvite'
import type { AgendaParticipant } from '../types'

interface Props {
  /** Seçicinin odaklanan girdisi — çağıran `<label htmlFor>` bağlar. */
  inputId: string
  value: AgendaParticipant[]
  onChange: (next: AgendaParticipant[]) => void
}

/**
 * **Grup daveti** — Liste Yönetimi'nde seçilen listenin kişileri davetlilere eklenir; zaten davetli
 * olan atlanır (bkz. {@link withListMembers}). Atlanan kişi varsa söylenir: listenin tamamı zaten
 * davetliyken seçim hiçbir şey yapmıyor gibi görünmesin (tutanaktaki emsal, 119).
 */
export default function AgendaGroupInviteField({ inputId, value, onChange }: Readonly<Props>) {
  const { t } = useTranslation()
  const toast = useToast()

  const addList = (list: ManagerList) => {
    const { next, skipped } = withListMembers(value, list)
    if (next !== value) onChange(next)
    if (skipped > 0) toast.warn(t('agenda.form.groupSkipped', { count: skipped }))
  }

  return (
    <ManagerListPicker
      inputId={inputId}
      onPick={addList}
      placeholder={t('agenda.form.groupInviteHint')}
    />
  )
}
